import React from 'react';

export default function Handle({ // your handle component
    handle: { id, value, percent },
    disabled,
    getHandleProps
}) {
  return (
    <div
      style={{
        left: `${percent}%`,
        position: 'absolute',
        marginLeft: -15,
        marginTop: 14,
        zIndex: 2,
        width: 24,
        height: 24,
        textAlign: 'center',
        cursor: 'pointer',
        borderRadius: '50%',
        backgroundColor: '#FFFFFF',
        color: '#333',
        border: disabled?'1px solid #B6B9BF':'1px solid #1F3C9C'
      }}
      {...getHandleProps(id)}
    >
      <div style={{ fontSize: 13, marginTop: 30, color: disabled?'#B6B9BF':'inherit' }}>
        {value}
      </div>
    </div>
  )
}